import { createFileRoute } from "@tanstack/react-router";
import { ProductPage } from "@/components/site/ProductPage";
import { HardMoneyCalculator } from "@/components/site/HardMoneyCalculator";
import { getProduct } from "@/data/products";
import { getProductHero } from "@/data/productHeroes";
import { buildHead } from "@/lib/seo-head";

const SLUG = "hard-money-loans";
const PRODUCT = getProduct(SLUG)!;
const HERO = getProductHero(SLUG);
const URL = `/${SLUG}`;

const KEYWORDS = [
  "hard money loan",
  "private money loan",
  "asset based lending",
  "hard money lender for investors",
  "fast closing hard money loan",
  "hard money loan rates",
  "hard money cash out refinance",
  "hard money land loan",
  "hard money loan for LLC",
  "bridge hard money financing",
  "hard money rehab loan",
  "private money real estate loan",
].join(", ");

export const Route = createFileRoute("/hard-money-loans/")({
  head: () =>
    buildHead({
      title: "Hard Money & Private Money Loans for Investors",
      description:
        "Asset-based hard money and private money loans — 5–14 day closings, up to 80% of as-is value for acquisitions, rehab, land, cash-out, and payoffs.",
      url: URL,
      keywords: KEYWORDS,
      image: HERO?.src,
      imageAlt: HERO?.alt,
      breadcrumbs: [
        { name: "Home", url: "/" },
        { name: PRODUCT.shortName, url: URL },
      ],
      service: { name: PRODUCT.name },
      faqs: PRODUCT.faq.map((f) => ({ q: f.q, a: f.a })),
    }),

  component: () => (
    <ProductPage
      product={PRODUCT}
      hideBaseTools
      extraTools={
        <>
          <HardMoneyCalculator />
        </>
      }
    />
  ),
});
